import { post } from '@/utils/request'

/**
 * 淘客的多麦订单列表
 * @param {object} data 请求参数
 * @param {string} data.trade_id 多麦订单号
 * @param {string} data.inv_user_telephone 邀请者手机号
 * @param {string} data.telephone 相关手机号，归属者，一级邀请者，二级邀请者
 * @param {string} data.create_time_begin 下单时间开始 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {string} data.create_time_end 下单时间结束 \d{4,4}-\d{2,2}-\d{2,2} \d{2,2}:\d{2,2}:\d{2,2}
 * @param {string} data.owner_cms_member_id 归属代理/CMS会员ID
 * @param {string} data.tk_status 订单状态： -1 无效 0 未确认 1 确认 2 结算
 * @param {string} data.ads_id 订单状态： 计划ID 滴滴打车（计划ID：12485）花小猪打车（计划ID：14801） 美团 10124 
 * @param {string} data.page 页码
 * @param {string} data.pagesize 分页大小
 */
export default function taoke_duomai_order_list(data) {
  return post('taoke_duomai_order_list', data)
}